// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_wgF","cls2":"PaperAbstract-cls2__Iv PaperAbstract-cls1_wgF","isSnippet":"PaperAbstract-isSnippet_OEX","variant-dense":"PaperAbstract-variant-dense_duF"};